module.exports = __webpack_public_path__ + "static/media/67828930_663352584151361_3981007518829641728_o.6b8e99bd.jpg";